import config from "../../config"
import RequestService from "../RequestService"

const deleteMaterial = (id, successCallback, failureCallback) => {
  RequestService.delete(`${config.backendUrl}/materials/${id}`, successCallback, failureCallback)
}

export default deleteMaterial;